import ManuelPageListBlock from './manuel-page-list-block';

export default ManuelPageListBlock;
